import { get, getOrThrow, set, watch } from 'quartz/globalState/api';
import { BREEZE_ASSISTANT_ENABLED, BREEZE_ASSISTANT_SIDEBAR_BACKGROUND, COPILOT_LAYOUT_TYPE, COPILOT_SIDEBAR_SIDE } from './globalState';
/**
 * Returns the name of the current package.
 *
 * @example
 * ```ts
 * import { getCopilotLayoutType } from 'quartz/framework/copilot/service';
 *
 * console.log(getCopilotLayoutType()); // 'sidebar'
 * ```
 */
export const getCopilotLayoutType = () => getOrThrow(COPILOT_LAYOUT_TYPE);
export const setCopilotLayoutType = type => set(COPILOT_LAYOUT_TYPE, type);
export const watchCopilotLayoutType = watch(COPILOT_LAYOUT_TYPE);
export const getCopilotSidebarSide = () => {
  var _get;
  return (_get = get(COPILOT_SIDEBAR_SIDE)) !== null && _get !== void 0 ? _get : 'left';
};
export const setCopilotSidebarSide = side => set(COPILOT_SIDEBAR_SIDE, side);
export const watchCopilotSidebarSide = watch(COPILOT_SIDEBAR_SIDE);

/**
 * Whether Breeze Assistant is enabled for the current app. Apps opt out by
 * setting
 * `breezeAssistantOptions: { enabled: false }` in their quartz config.
 *
 * @example
 * ```ts
 * import { getBreezeAssistantEnabled } from 'quartz/framework/copilot/service';
 *
 * console.log(getBreezeAssistantEnabled()); // true
 * ```
 */
export const getBreezeAssistantEnabled = () => {
  var _get2;
  return (_get2 = get(BREEZE_ASSISTANT_ENABLED)) !== null && _get2 !== void 0 ? _get2 : true;
};
export const setBreezeAssistantEnabled = enabled => set(BREEZE_ASSISTANT_ENABLED, enabled);
export const watchBreezeAssistantEnabled = watch(BREEZE_ASSISTANT_ENABLED);

/**
 * The sidebar background style configured for the current app. Apps opt in to
 * a grey background by setting
 * `breezeAssistantOptions: { sidebarBackground: 'modern' }` in their quartz
 * config. Returns `undefined` when the app has not set the field.
 *
 * @example
 * ```ts
 * import { getBreezeAssistantSidebarBackground } from 'quartz/framework/copilot/service';
 *
 * console.log(getBreezeAssistantSidebarBackground()); // 'modern' | 'legacy' | undefined
 * ```
 */
export const getBreezeAssistantSidebarBackground = () => get(BREEZE_ASSISTANT_SIDEBAR_BACKGROUND);
export const setBreezeAssistantSidebarBackground = background => set(BREEZE_ASSISTANT_SIDEBAR_BACKGROUND, background);
export const watchBreezeAssistantSidebarBackground = watch(BREEZE_ASSISTANT_SIDEBAR_BACKGROUND);